"use strict";

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.parse-int");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));
/* tslint:disable */


exports["default"] = function (_a) {
  var _b = _a.width,
      width = _b === void 0 ? '30px' : _b,
      _c = _a.height,
      height = _c === void 0 ? '30px' : _c,
      _d = _a.color,
      color = _d === void 0 ? '#000' : _d,
      _e = _a.bgColor,
      bgColor = _e === void 0 ? '#FFF' : _e,
      rest = __rest(_a, ["width", "height", "color", "bgColor"]);

  return react_1["default"].createElement("svg", __assign({}, rest, {
    width: width,
    height: height,
    viewBox: "0 0 " + Number.parseInt(width) + " " + Number.parseInt(height)
  }), react_1["default"].createElement("g", {
    stroke: 'none',
    fill: 'none',
    strokeWidth: '1',
    fillRule: 'evenodd'
  }, react_1["default"].createElement("g", {
    transform: 'translate(-360.000000, -2224.000000)',
    fill: '#064650',
    fillRule: 'nonzero'
  }, react_1["default"].createElement("g", {
    transform: 'translate(360.000000, 2223.000000)'
  }, react_1["default"].createElement("g", null, react_1["default"].createElement("g", {
    transform: 'translate(0.000000, 1.000000)'
  }, react_1["default"].createElement("path", {
    d: 'M5.91758147,27.1682585 C5.22289518,26.6942074 4.57464964,26.1575914 3.98104286,25.566592 C1.52177143,23.1182507 -4.61852778e-14,19.7366187 -4.61852778e-14,16.0015787 C-4.61852778e-14,12.2665387 1.52177143,8.88477867 3.98104286,6.43656533 C4.57453424,5.844908 5.22289169,5.30787536 5.91784135,4.83358912 C5.91467303,4.8072755 5.91304286,4.78048948 5.91304286,4.75332267 L5.91304286,0.666666667 C5.91304286,0.298333867 6.21270857,8.17124146e-14 6.58268571,8.17124146e-14 L20.5931143,8.17124146e-14 C20.9630914,8.17124146e-14 21.2627571,0.298333867 21.2627571,0.666666667 L21.2627571,4.75332267 C21.2627571,4.78047888 21.2611282,4.80725461 21.2579624,4.83355833 C21.9533944,5.30793826 22.602305,5.84500876 23.1964714,6.43656533 C24.3729176,7.60778284 25.3348266,8.9925742 26.0182381,10.5274594 L27.5897814,9.9094958 L27.3082286,9.19982933 C27.1726329,8.85819733 27.3417471,8.46984107 27.6849043,8.334848 C28.0280614,8.19985493 28.4181429,8.36818347 28.5537471,8.7098496 L29.6084186,11.3681963 C29.7440143,11.7098283 29.5749,12.0981845 29.2317429,12.2331776 C28.8885857,12.3681707 28.4985043,12.1998421 28.3629,11.858176 L28.081761,11.1495525 L26.4995644,11.7717052 C26.9394828,13.1024686 27.1775143,14.524384 27.1775143,16.0015787 C27.1775143,17.4780858 26.9397043,18.8993852 26.5001785,20.2296303 L28.0811334,20.8512947 L28.36281,20.1413163 C28.49841,19.799648 28.8884593,19.6313173 29.2316529,19.7663147 C29.5748464,19.901312 29.7439329,20.2896299 29.6083286,20.631296 L29.0875125,21.9440362 C29.085405,21.9498035 29.0832119,21.955559 29.0809329,21.9613013 C29.0786747,21.9669912 29.0763459,21.9726331 29.073948,21.9782262 L28.5536571,23.2896427 C28.4180571,23.6313109 28.0280079,23.7996416 27.6848143,23.6646443 C27.3416207,23.5296469 27.1725343,23.1413291 27.3081386,22.7996629 L27.5891538,22.0913514 L26.0190387,21.4739494 C25.335578,23.0095653 24.3733771,24.3949783 23.1964714,25.566592 C22.6023953,26.1580277 21.9536148,26.6949997 21.2583406,27.1693083 C21.2612579,27.1945801 21.2627571,27.220283 21.2627571,27.246336 L21.2627571,31.332992 C21.2627571,31.7013248 20.9630914,31.9996587 20.5931143,31.9996587 L6.58268571,31.9996587 C6.21270857,31.9996587 5.91304286,31.7013248 5.91304286,31.332992 L5.91304286,27.246336 C5.91304286,27.2199221 5.91458392,27.1938682 5.91758147,27.1682585 Z M7.25232857,27.9711794 L7.25232857,30.6663253 L19.9234714,30.6663253 L19.9234714,27.9720516 C18.0319028,28.9666918 15.8763182,29.5299413 13.5887571,29.5299413 C11.3005275,29.5299413 9.14430377,28.9663626 7.25232857,27.9711794 Z M7.25232857,4.03090029 C9.14424024,3.03604254 11.3007983,2.473216 13.5887571,2.473216 C15.8762744,2.473216 18.0318968,3.03645677 19.9234714,4.03108261 L19.9234714,1.33333333 L7.25232857,1.33333333 L7.25232857,4.03090029 Z M13.5524877,14.618746 C13.5645394,14.6184377 13.5766298,14.6182827 13.5887571,14.6182827 C13.9721271,14.6182827 14.3186571,14.7716181 14.5698,15.0216149 C14.6616433,15.11305 14.7404978,15.2174133 14.8035792,15.3316096 L20.3524629,15.3316096 C20.72244,15.3316096 21.0221057,15.6299435 21.0221057,15.9982763 C21.0221057,16.3666091 20.72244,16.6649429 20.3524629,16.6649429 L14.8038247,16.6649429 C14.7407021,16.7791162 14.6617618,16.8834162 14.5698,16.9749803 C14.3186829,17.2249813 13.9704857,17.3783125 13.5887571,17.3783125 C13.2053871,17.3783125 12.8588571,17.2249771 12.6077143,16.9749803 C12.3565971,16.7249792 12.2025814,16.3783296 12.2025814,15.9982976 C12.2025814,15.7401088 12.2730645,15.4987038 12.3964076,15.2921268 L8.59503429,7.72317013 C8.43265714,7.39485013 8.56657714,6.99652267 8.8947,6.83152213 C9.22448571,6.66986667 9.62459143,6.8031872 9.79032857,7.129856 L13.5524877,14.618746 Z M22.2471857,7.37646933 C20.0306571,5.169792 16.9706143,3.806464 13.5853286,3.806464 C10.2019714,3.806464 7.14004286,5.171456 4.92347143,7.37646933 C2.71028571,9.58314667 1.34087143,12.6330027 1.34087143,15.9998293 C1.34087143,19.366656 2.71195714,22.4164693 4.92681429,24.6231893 C7.14334286,26.8298667 10.2033857,28.1931947 13.5886714,28.1931947 C16.9720286,28.1931947 20.0339571,26.8282027 22.2505286,24.6231893 C24.4637143,22.416512 25.8348,19.366656 25.8348,15.9998293 C25.8348,12.6330027 24.4637143,9.58318933 22.2471857,7.37646933 Z M13.6222393,15.9666347 C13.6138689,15.9583014 13.60215,15.9516348 13.5887571,15.9516348 C13.5753643,15.9516348 13.5636454,15.9583014 13.555275,15.9666347 C13.5469046,15.9749679 13.5402081,15.9866347 13.5402081,15.999968 C13.5402081,16.0133013 13.5469046,16.0249681 13.555275,16.0333013 C13.5636454,16.0416346 13.5753643,16.0483012 13.5887571,16.0483012 C13.60215,16.0483012 13.6138689,16.0416346 13.6222393,16.0333013 C13.6306097,16.0249681 13.6373061,16.0133013 13.6373061,15.999968 C13.6373061,15.9866347 13.6306097,15.9749679 13.6222393,15.9666347 Z'
  })))))));
};
/* tslint:enable */